import React, { useState, useEffect, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useTheme, alpha } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  getAllProyectos,
  updateProyecto,
} from "../../api/Proyectos/proyectoApi";
import {
  getCustomerById,
  updateCustomer,
  getMarcasClient,
  getCustomers,
} from "../../api/Customer/customerApi";

import { jwtDecode } from "jwt-decode";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import Drawer from "@mui/material/Drawer";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import Collapse from "@mui/material/Collapse";

import CustomerForm from "../Customer/CustomerForm";

import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";

import ListAltIcon from "@mui/icons-material/ListAlt";
import EditIcon from "@mui/icons-material/Edit";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import ViewKanbanOutlinedIcon from "@mui/icons-material/ViewKanbanOutlined";

import { makeStyles } from "@mui/styles";

import { SidebarContext } from "../Sidebar/SidebarProvider";
import {
  pageFieldSx,
  pageHeroShellSx,
  pageMobileCardSx,
} from "../../styles/pageModernStyles";

const estados = [
  "New",
  "Selección Prendas",
  "Desarrollo Protos",
  "Cotizando",
  "Pte Decisión",
  "SMS",
  "Pte Pedido",
  "Ganado",
  "Perdido",
];

const responsables = [
  "Irene",
  "Lydia",
  "Imma",
  "Sara",
  "Agustina",
  "Laura",
  "Chiara",
  "Alex",
  "Borja",
  "Miguel",
  "Mikael",
];

const procedencias = ["Aotai", "HS Fashion", "No Man's Label", "Stage"];

const KanbanProyectos = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { t } = useTranslation();
  const { contentMargin } = useContext(SidebarContext);
  const accent = theme.palette.primary.main;
  const [filtersOpen, setFiltersOpen] = useState(false);

  const useStyles = makeStyles(() => ({
    kanbanContainer: {
      display: "flex",
      gap: "16px",
      overflowX: "auto",
      scrollSnapType: "x mandatory",
      scrollBehavior: "smooth",
      paddingBottom: "8px",
      WebkitOverflowScrolling: "touch",
    },
    kanbanColumn: {
      flex: "0 0 250px",
      display: "flex",
      flexDirection: "column",
      maxHeight: "calc(100dvh - 220px)",
      overflowY: "auto",
      padding: "0",
      borderRadius: "6px",
      scrollSnapAlign: "start",
    },
    columnGanado: { color: "green" },
    columnPerdido: { color: "red" },
  }));
  const classes = useStyles();
  const [proyectos, setProyectos] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedResponsables, setSelectedResponsables] = useState([]);
  const [selectedEstados, setSelectedEstados] = useState([]);
  const [selectedProcedencia, setSelectedProcedencia] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [currentCustomerId, setCurrentCustomerId] = useState(null);
  const [responsablesData, setResponsablesData] = useState({});

  const [refreshKey, setRefreshKey] = useState(0); // Nuevo estado para forzar la actualización

  const token = localStorage.getItem("token");
  const username = jwtDecode(token).username;

  const navigate = useNavigate();

  // Fetch all projects and their respective sales managers
  // useEffect(() => {
  //   const token = localStorage.getItem("token");
  //   const decoded = jwtDecode(token);
  //   const username = decoded.username;
  //   const isAdmin = decoded.isAdmin;

  //   getAllProyectos().then(async (data) => {
  //     const filteredData = [];
  //     const filteredResponsables = [];

  //     for (const proyecto of data) {
  //       if (proyecto.customerId) {
  //         const customer = await getCustomerById(proyecto.customerId);

  //         // 🔍 Si es admin, ve todo. Si no, solo si es su cliente.
  //         if (isAdmin || customer.responsableVentas === username) {
  //           const marca = await getMarcasClient().then((marcas) =>
  //             marcas.find((m) => m.ID_MARCA === proyecto.marcaId)
  //           );

  //           filteredData.push(proyecto);
  //           filteredResponsables.push({
  //             projectId: proyecto.id,
  //             customerName: customer.name,
  //             responsableVentas: customer.responsableVentas,
  //             procedencia: customer.procedencia,
  //             marcaProyecto: marca?.MARCA || "Sin Marca",
  //           });
  //         }
  //       }
  //     }

  //     // Agrupar por estado
  //     const groupedProyectos = estados.reduce((acc, estado) => {
  //       acc[estado] = filteredData.filter(
  //         (proyecto) => proyecto.status === estado
  //       );
  //       return acc;
  //     }, {});
  //     setProyectos(groupedProyectos);

  //     // Mapear responsables
  //     const responsablesMap = filteredResponsables.reduce((acc, item) => {
  //       acc[item.projectId] = item;
  //       return acc;
  //     }, {});
  //     setResponsablesData(responsablesMap);
  //   });
  // }, [refreshKey]);

  useEffect(() => {
    const loadData = async () => {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const username = decoded.username;
      const isAdmin = decoded.isAdmin;

      // 1️⃣ Cargar TODO en paralelo (solo 3 llamadas)
      const [proyectosData, customersData, marcasData] = await Promise.all([
        getAllProyectos(),
        getCustomers(), // ⚡️ trae todos los clientes de golpe
        getMarcasClient(), // ⚡️ trae todas las marcas una sola vez
      ]);

      // 2️⃣ Crear indexación rápida por ID (O(1))
      const customerMap = Object.fromEntries(
        customersData.map((c) => [c.id, c])
      );

      const marcaMap = Object.fromEntries(
        marcasData.map((m) => [m.ID_MARCA, m.MARCA])
      );

      // 3️⃣ Procesar proyectos sin llamadas extra
      const filteredData = [];
      const responsablesInfo = [];

      for (const proyecto of proyectosData) {
        const customer = customerMap[proyecto.customerId];

        if (!customer) continue;

        if (!isAdmin && customer.responsableVentas !== username) continue;

        filteredData.push(proyecto);

        responsablesInfo.push({
          projectId: proyecto.id,
          customerName: customer.name,
          responsableVentas: customer.responsableVentas,
          procedencia: customer.procedencia,
          marcaProyecto: marcaMap[proyecto.marcaId] || "Sin Marca",
        });
      }

      // 4️⃣ Agrupar por estado
      const grouped = estados.reduce((acc, estado) => {
        acc[estado] = filteredData.filter((p) => p.status === estado);
        return acc;
      }, {});

      setProyectos(grouped);

      // 5️⃣ Mapear responsables
      const mapResp = Object.fromEntries(
        responsablesInfo.map((r) => [r.projectId, r])
      );
      setResponsablesData(mapResp);
    };

    loadData();
  }, [refreshKey]);

  // Abrir drawer y cargar el formulario del cliente
  const handleOpenDrawer = (customerId) => {
    setCurrentCustomerId(customerId);
    setDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setCurrentCustomerId(null);
  };

  const handleFormSubmit = async (customer) => {
    if (currentCustomerId) {
      try {
        await updateCustomer(currentCustomerId, customer);
        setRefreshKey((prevKey) => prevKey + 1); // Forzar la actualización del Kanban
        handleCloseDrawer();
      } catch (error) {
        console.error("Error al actualizar el cliente:", error);
      }
    }
  };

  const onDragEnd = async (result) => {
    const { source, destination, draggableId } = result;
    if (!destination) return;

    const sourceEstado = source.droppableId;
    const destEstado = destination.droppableId;
    if (sourceEstado === destEstado) return;

    const proyecto = proyectos[sourceEstado].find(
      (p) => p.id.toString() === draggableId
    );

    if (!proyecto) return;

    // Update the project status
    await updateProyecto(proyecto.id, { ...proyecto, status: destEstado });

    const newSourceList = proyectos[sourceEstado].filter(
      (p) => p.id.toString() !== draggableId
    );
    const newDestList = [
      ...proyectos[destEstado],
      { ...proyecto, status: destEstado },
    ];

    setProyectos((prevProyectos) => ({
      ...prevProyectos,
      [sourceEstado]: newSourceList,
      [destEstado]: newDestList,
    }));
  };

  const getResponsableAccent = (responsableVentas) => {
    switch (responsableVentas) {
      case "Irene":
        return "#2e7d32";
      case "Lydia":
        return "#c2185b";
      case "Imma":
        return "#0288d1";
      case "Sara":
        return "#5c6bc0";
      case "Agustina":
        return "#8d6e63";
      case "Laura":
        return "#78909c";
      case "Chiara":
        return "#7cb342";
      case "Alex":
        return "#ab47bc";
      case "Borja":
        return "#c62828";
      case "Miguel":
        return "#ef6c00";
      case "Mikael":
        return "#00695c";
      default:
        return theme.palette.text.secondary;
    }
  };

  const getResponsableChipSx = (responsableVentas) => {
    const color = getResponsableAccent(responsableVentas);
    return {
      height: 24,
      fontWeight: 700,
      fontSize: "0.72rem",
      bgcolor: alpha(color, 0.1),
      color,
      border: "1px solid",
      borderColor: alpha(color, 0.24),
    };
  };

  const getEstadoLabel = (estado) =>
    t(`Projects.${estado.replace(/ /g, "")}`);

  const formatNum = (value) =>
    Number(value || 0).toLocaleString("de-DE", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

  const getColumnClass = (estado) => {
    switch (estado) {
      case "Ganado":
        return classes.columnGanado;
      case "Perdido":
        return classes.columnPerdido;
      default:
        return "";
    }
  };

  const filteredProyectos = () => {
    let filtered = { ...proyectos };

    // 🔹 Ocultar "Ganado" y "Perdido" por defecto si no están en el filtro
    if (selectedEstados.length === 0) {
      const { Ganado, Perdido, ...rest } = filtered;
      filtered = rest;
    }

    if (searchTerm) {
      filtered = Object.keys(filtered).reduce((acc, estado) => {
        acc[estado] = filtered[estado].filter((proyecto) => {
          const subject = proyecto.subject.toLowerCase();
          return subject.includes(searchTerm.toLowerCase());
        });
        return acc;
      }, {});
    }

    if (selectedResponsables.length > 0) {
      filtered = Object.keys(filtered).reduce((acc, estado) => {
        acc[estado] = filtered[estado].filter((proyecto) =>
          selectedResponsables.includes(
            responsablesData[proyecto.id]?.responsableVentas
          )
        );
        return acc;
      }, {});
    }

    if (selectedEstados.length > 0) {
      filtered = Object.keys(filtered).reduce((acc, estado) => {
        if (selectedEstados.includes(estado)) {
          acc[estado] = filtered[estado];
        }
        return acc;
      }, {});
    }

    if (selectedProcedencia.length > 0) {
      filtered = Object.keys(filtered).reduce((acc, estado) => {
        acc[estado] = filtered[estado].filter((proyecto) =>
          selectedProcedencia.includes(
            responsablesData[proyecto.id]?.procedencia
          )
        );
        return acc;
      }, {});
    }

    return filtered;
  };

  const filterInputSx = {
    width: { xs: "100%", sm: 160, md: 176 },
    minWidth: 0,
    ...pageFieldSx(theme),
    "& .MuiInputBase-root": {
      ...pageFieldSx(theme)["& .MuiInputBase-root"],
      backgroundColor: theme.palette.caja?.main || theme.palette.background.paper,
    },
  };

  const searchFieldSx = {
    ...filterInputSx,
    width: { xs: "100%", sm: 280, md: 320 },
  };

  const activeFilterCount = useMemo(() => {
    let count = 0;
    if (selectedResponsables.length) count += 1;
    if (selectedEstados.length) count += 1;
    if (selectedProcedencia.length) count += 1;
    return count;
  }, [selectedResponsables, selectedEstados, selectedProcedencia]);

  const visibleProyectos = useMemo(
    () => filteredProyectos(),
    [
      proyectos,
      searchTerm,
      selectedResponsables,
      selectedEstados,
      selectedProcedencia,
      responsablesData,
    ],
  );

  const totalCards = useMemo(
    () =>
      Object.values(visibleProyectos).reduce(
        (count, column) => count + column.length,
        0,
      ),
    [visibleProyectos],
  );

  const renderFilters = () => (
    <>
      <FormControl variant="outlined" size="small" sx={filterInputSx}>
        <InputLabel>{t("Clientes.AccManager")}</InputLabel>
        <Select
          multiple
          value={selectedResponsables}
          onChange={(e) => setSelectedResponsables(e.target.value)}
          label={t("Clientes.AccManager")}
          renderValue={(selected) => selected.join(", ")}
        >
          {responsables.map((responsable) => (
            <MenuItem key={responsable} value={responsable}>
              <Checkbox
                checked={selectedResponsables.indexOf(responsable) > -1}
              />
              <ListItemText primary={responsable} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" size="small" sx={filterInputSx}>
        <InputLabel>{t("Clientes.Origin")}</InputLabel>
        <Select
          multiple
          value={selectedProcedencia}
          onChange={(e) => setSelectedProcedencia(e.target.value)}
          label={t("Clientes.Origin")}
          renderValue={(selected) => selected.join(", ")}
        >
          {procedencias.map((procedencia) => (
            <MenuItem key={procedencia} value={procedencia}>
              <Checkbox
                checked={selectedProcedencia.indexOf(procedencia) > -1}
              />
              <ListItemText primary={procedencia} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" size="small" sx={filterInputSx}>
        <InputLabel>{t("Projects.Status")}</InputLabel>
        <Select
          multiple
          value={selectedEstados}
          onChange={(e) => setSelectedEstados(e.target.value)}
          label={t("Projects.Status")}
          renderValue={(selected) =>
            selected.map((estado) => getEstadoLabel(estado)).join(", ")
          }
        >
          {estados.map((estado) => (
            <MenuItem key={estado} value={estado}>
              <Checkbox checked={selectedEstados.indexOf(estado) > -1} />
              <ListItemText primary={getEstadoLabel(estado)} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );

  const renderKanbanCard = (proyecto, provided) => {
    const meta = responsablesData[proyecto.id] || {};
    const responsable = meta.responsableVentas || "—";

    if (isMobile) {
      return (
        <Paper
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          sx={{
            ...pageMobileCardSx(theme, { accentColor: accent }),
            mb: 1,
            p: 1.25,
            cursor: "grab",
          }}
        >
          <Typography sx={{ fontWeight: 800, fontSize: "0.88rem", lineHeight: 1.25 }}>
            {meta.marcaProyecto || "Sin marca"}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
            {proyecto.proyectType || "—"}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 700,
              mt: 0.35,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {proyecto.subject}
          </Typography>
          <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap" sx={{ mt: 0.75 }}>
            <Chip
              size="small"
              label={`€P ${formatNum(proyecto.previsionVenta)}`}
              sx={{ height: 22, fontSize: "0.68rem", fontWeight: 700 }}
            />
            {responsable !== "—" ? (
              <Chip
                size="small"
                label={responsable}
                sx={getResponsableChipSx(responsable)}
              />
            ) : null}
          </Stack>
          <Stack direction="row" spacing={0.75} sx={{ mt: 1 }}>
            <Button
              size="small"
              fullWidth
              variant="outlined"
              startIcon={<ListAltIcon />}
              onClick={() => navigate(`/proyectos/${proyecto.id}/tareas`)}
              sx={{ textTransform: "none", fontWeight: 700 }}
            >
              ToDo
            </Button>
            <Button
              size="small"
              fullWidth
              variant="outlined"
              startIcon={<EditIcon />}
              onClick={() => handleOpenDrawer(proyecto.customerId)}
              sx={{ textTransform: "none", fontWeight: 700 }}
            >
              Edit
            </Button>
          </Stack>
        </Paper>
      );
    }

    return (
      <Tooltip title={proyecto.notes || "No notes"} arrow>
        <Paper
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          elevation={0}
          sx={{
            p: 1.25,
            mb: 1,
            borderRadius: 2,
            border: "1px solid",
            borderColor: alpha(theme.palette.divider, 0.75),
            bgcolor: theme.palette.background.paper,
            boxShadow: `0 1px 3px ${alpha(theme.palette.common.black, 0.05)}`,
            "&:hover": {
              borderColor: alpha(accent, 0.35),
              boxShadow: `0 4px 12px ${alpha(accent, 0.1)}`,
            },
          }}
        >
          <Typography sx={{ fontWeight: 800, fontSize: "0.88rem" }}>
            {meta.marcaProyecto || "Sin marca"}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
            {proyecto.proyectType}
          </Typography>
          <Typography
            sx={{
              fontWeight: 700,
              mt: 0.35,
              fontSize: "0.84rem",
              lineHeight: 1.3,
            }}
          >
            {proyecto.subject}
          </Typography>
          {proyecto.notes ? (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{
                display: "block",
                mt: 0.5,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {proyecto.notes}
            </Typography>
          ) : null}
          <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap" sx={{ mt: 0.75 }}>
            {responsable !== "—" ? (
              <Chip size="small" label={responsable} sx={getResponsableChipSx(responsable)} />
            ) : null}
            <Chip
              size="small"
              label={`€P ${formatNum(proyecto.previsionVenta)} | ${formatNum(proyecto.previsionPrendas)} u`}
              sx={{
                height: 24,
                fontSize: "0.68rem",
                fontWeight: 600,
                bgcolor: alpha(theme.palette.background.default, 0.8),
              }}
            />
            <Chip
              size="small"
              label={`€R ${formatNum(proyecto.ventaFinal)} | ${formatNum(proyecto.prendasFinal)} u`}
              sx={{
                height: 24,
                fontSize: "0.68rem",
                fontWeight: 600,
                bgcolor: alpha(accent, 0.08),
              }}
            />
          </Stack>
          <Stack direction="row" spacing={0.75} sx={{ mt: 1 }}>
            <Button
              size="small"
              fullWidth
              variant="outlined"
              startIcon={<ListAltIcon />}
              onClick={() => navigate(`/proyectos/${proyecto.id}/tareas`)}
              sx={{ textTransform: "none", fontWeight: 700 }}
            >
              ToDo
            </Button>
            <Button
              size="small"
              fullWidth
              variant="outlined"
              startIcon={<EditIcon />}
              onClick={() => handleOpenDrawer(proyecto.customerId)}
              sx={{ textTransform: "none", fontWeight: 700 }}
            >
              Edit
            </Button>
          </Stack>
        </Paper>
      </Tooltip>
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100dvh",
        boxSizing: "border-box",
        overflow: "auto",
        pt: 2,
        pl: { xs: 1.25, sm: 2 },
        pr: { xs: 1.25, md: 3 },
        pb: { xs: 10, sm: 2 },
        ...contentMargin,
      }}
    >
      <Box sx={pageHeroShellSx(theme, { sticky: !isMobile })}>
        <Box sx={{ p: { xs: 1.25, sm: 1.75 } }}>
          <Stack
            direction={{ xs: "column", lg: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "stretch", lg: "flex-start" }}
            spacing={1.5}
          >
            <Stack direction="row" spacing={1.25} alignItems="flex-start">
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: 2,
                  flexShrink: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: alpha(accent, 0.16),
                  color: theme.palette.primary.dark,
                  border: "1px solid",
                  borderColor: alpha(accent, 0.28),
                }}
              >
                <ViewKanbanOutlinedIcon fontSize="small" />
              </Box>
              <Box>
                <Typography
                  variant="overline"
                  color="text.secondary"
                  sx={{ fontWeight: 700, letterSpacing: 1.1 }}
                >
                  CRM
                </Typography>
                <Typography
                  variant={isMobile ? "h5" : "h4"}
                  sx={{ fontWeight: 800, lineHeight: 1.1 }}
                >
                  {t("sidebar.kanbanProjects")}
                </Typography>
                <Chip
                  size="small"
                  label={`${totalCards} ${t("Projects.Projects", { defaultValue: "proyectos" }).toLowerCase()}`}
                  sx={{
                    mt: 0.75,
                    fontWeight: 700,
                    bgcolor: alpha(accent, 0.1),
                    color: theme.palette.primary.dark,
                  }}
                />
              </Box>
            </Stack>

            <Stack
              direction="row"
              spacing={1}
              flexWrap="wrap"
              useFlexGap
              alignItems="center"
              sx={{ width: { xs: "100%", lg: "auto" } }}
            >
              <TextField
                label={t("Clientes.search")}
                variant="outlined"
                size="small"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                sx={searchFieldSx}
              />
              {isMobile ? (
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<FilterListOutlinedIcon />}
                  onClick={() => setFiltersOpen((open) => !open)}
                  sx={{ fontWeight: 700, textTransform: "none" }}
                >
                  {t("Clientes.filters", { defaultValue: "Filtros" })}
                  {activeFilterCount > 0 ? ` (${activeFilterCount})` : ""}
                </Button>
              ) : null}
            </Stack>
          </Stack>

          <Collapse in={!isMobile || filtersOpen}>
            <Box
              sx={{
                mt: 1.5,
                display: "flex",
                flexWrap: "wrap",
                gap: 1.25,
                alignItems: "center",
              }}
            >
              {renderFilters()}
            </Box>
          </Collapse>

          {isMobile ? (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: "block", mt: 1, fontWeight: 600 }}
            >
              {t("kanban.swipeHint", {
                defaultValue: "Desliza horizontalmente para ver cada estado.",
              })}
            </Typography>
          ) : null}
        </Box>
      </Box>

      <DragDropContext onDragEnd={onDragEnd}>
        <Box
          className={classes.kanbanContainer}
          sx={{
            flex: 1,
            minHeight: 0,
            gap: { xs: 1, md: 2 },
            px: { xs: 0.25, md: 0 },
            scrollSnapType: "x mandatory",
          }}
        >
          {Object.keys(visibleProyectos).map((estado) => (
            <Droppable key={estado} droppableId={estado}>
              {(provided) => (
                <Box
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  className={classes.kanbanColumn}
                  sx={{
                    flex: { xs: "0 0 86vw", sm: "0 0 72vw", md: "0 0 250px" },
                    maxWidth: { xs: 360, md: 250 },
                    maxHeight: {
                      xs: "calc(100dvh - 260px)",
                      md: "calc(100dvh - 220px)",
                    },
                    borderRadius: 2.5,
                    border: "1px solid",
                    borderColor: "divider",
                    backgroundColor:
                      theme.palette.mode === "dark"
                        ? theme.palette.background.paper
                        : alpha(theme.palette.background.default, 0.7),
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 800,
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                      backgroundColor: alpha(theme.palette.primary.main, 0.08),
                      px: 1,
                      py: 0.85,
                      textAlign: "center",
                      borderBottom: `1px solid ${theme.palette.divider}`,
                    }}
                    className={getColumnClass(estado)}
                  >
                    {getEstadoLabel(estado)}
                    <Box
                      component="span"
                      sx={{
                        ml: 0.75,
                        opacity: 0.7,
                        fontWeight: 700,
                        fontSize: "0.75rem",
                      }}
                    >
                      ({visibleProyectos[estado]?.length || 0})
                    </Box>
                  </Typography>
                  <Box sx={{ p: { xs: 0.75, md: 0.5 }, pt: 0.75 }}>
                    {visibleProyectos[estado]?.map((proyecto, index) => (
                      <Draggable
                        key={proyecto.id}
                        draggableId={proyecto.id.toString()}
                        index={index}
                      >
                        {(dragProvided) =>
                          renderKanbanCard(proyecto, dragProvided)
                        }
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </Box>
                </Box>
              )}
            </Droppable>
          ))}
        </Box>
      </DragDropContext>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={handleCloseDrawer}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 12,
            borderBottomLeftRadius: 12,
            border: "1px solid",
            borderColor: "divider",
            maxWidth: "100vw",
          },
        }}
      >
        <Box
          sx={{
            width: { xs: "100vw", sm: "100vw", md: 1000, lg: 1830 },
            maxWidth: "100vw",
            p: { xs: 1, sm: 1.5, md: 2 },
            backgroundColor: theme.palette.background.paper,
            minHeight: { xs: "100dvh", md: "auto" },
          }}
        >
          <CustomerForm
            customerId={currentCustomerId}
            onSubmit={handleFormSubmit}
            onClose={handleCloseDrawer}
          />
        </Box>
      </Drawer>
    </Box>
  );
};

export default KanbanProyectos;
